import data from '@roolz/icons/lottie/data/update.json'
import Lottie, { LottieComponentProps } from 'lottie-react'
import { useEffect, useLayoutEffect, useRef } from 'react'

type Props = Omit<LottieComponentProps, 'animationData'>

export const Update = (props: Props) => {
  const ref = useRef<any>()

  useLayoutEffect(() => {
    if(ref.current) {
      ref.current.setSpeed(0.4)
    }
  }, [ref.current])

  return (
    <Lottie
      lottieRef={ref}
      animationData={data}
      {...props}
    />
  )
}
